module.exports = __webpack_public_path__ + "static/media/VV_text_upd.13acb731.mp3";